<div class="w-screen h-screen flex flex-col" *ngIf="userLoaded$ | ngrxPush; else loading">
    <div class="w-full h-2 block bg-black" #environmentHeader></div>

    <div class="h-[calc(100%-0.5rem)] w-full flex flex-row items-stretch">
        <div class="h-full w-[320px]">
            <app-sidebar></app-sidebar>
        </div>
        <div class="bg-iota-bg relative h-full flex-1 overflow-y-auto overflow-x-hidden flex flex-col">
            <div class="min-h-[3rem] flex flex-row justify-start items-center px-5"><app-breadcrumbs></app-breadcrumbs></div>
            <router-outlet></router-outlet>
        </div>
    </div>

    <app-overlay-outlet></app-overlay-outlet>

    <div class="fixed top-4 right-4 z-[9999]" *ngIf="(toast$ | ngrxPush)?.visible">
        <app-feedback-toast
            [variant]="(toast$ | ngrxPush)?.variant"
            [header]="(toast$ | ngrxPush)?.header"
            [message]="(toast$ | ngrxPush)?.message"
            (closeMessage)="onToastClose()"
        >
        </app-feedback-toast>
    </div>
</div>

<ng-template #loading>
    <div class="w-screen h-screen flex items-center justify-center">
        <div class="spinner spinner-primary spinner-xl"></div>
    </div>
</ng-template>
